import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router';
import type { MilestoneChangeOrderListItem } from '@/api/Sherpa/ChangeOrder/index';
import { tdmStatus } from '@/constants/Project';
import { ActionsCell } from '@/features/ChangeOrder/Summary/Table/ActionsCell';
import { EditableCell } from '@/features/ChangeOrder/Summary/Table/EditableCell';
import { EditableStatus } from '@/features/ChangeOrder/Summary/Table/EditableStatus';
import type { ColMeta } from '@/features/ChangeOrder/Summary/Table/types';
import { useDeleteMilestoneChangeOrder } from '@/hooks/ReactQueryHooks/useChangeOrderDetailsQuery';

const columnHelper = createColumnHelper<MilestoneChangeOrderListItem>();

export const columns = [
  columnHelper.accessor('milestone', {
    header: 'Milestone',
    size: 120,
    cell: EditableCell,
    meta: {
      type: 'text',
      renderValue: ({ row, cell }) => (
        <Link className='underline' to={`milestones/${row.original.id}`}>
          {cell.getValue()}
        </Link>
      ),
    } as ColMeta,
  }),
  columnHelper.accessor('from', {
    header: 'From',
    size: 170,
    cell: EditableCell,
    meta: {
      type: 'date',
    },
  }),
  columnHelper.accessor('to', {
    header: 'To',
    size: 170,
    cell: EditableCell,
    meta: {
      type: 'date',
    },
  }),
  columnHelper.accessor('daysImpacted', {
    header: 'Impact (Days)',
    size: 150,
    cell: ({ cell }) => {
      const value = cell.getValue();
      return value > 0 ? `${value} days delayed` : `${value} days saved`;
    },
  }),
  columnHelper.accessor('approver', {
    header: 'Approver',
    size: 150,
    cell: EditableCell,
    meta: {
      type: 'select',
      renderValue: ({ row }) => row.original.approver.name,
    } as ColMeta,
  }),
  columnHelper.accessor('responseDueBy', {
    header: 'Response Due By',
    size: 150,
    cell: EditableCell,
    meta: {
      type: 'date',
    },
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    size: 150,
    cell: EditableStatus,
    meta: {
      options: Object.keys(tdmStatus).map((ts) => ({
        label: tdmStatus[ts],
        value: ts,
      })),
    },
  }),
  columnHelper.display({
    header: 'Actions',
    size: 90,
    cell: ActionsCell,
    meta: {
      deleteModalTitle: 'Are you sure you want to delete milestone?',
      useDeleteMutation: useDeleteMilestoneChangeOrder,
    },
  }),
];
